import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { Average, Club } from "../../store/Session/SessionModel";
import { tabsGroupClub, tabsGroupSim } from "../../config/TabsGroup";
import { normalizedKeys } from "../../config/NormalizedValues";
import { RootState } from "../../store/store";
import { LmLocation } from "../../models";

import "./style.css";

interface Props {
  tabSelected: "ball-data" | "club-data" | "key-data";
  club: Club;
}
// KWSA-24: In Simulator mode normalized values render white (no blue highlight), matching the Golf app.
const normalizedClass = (club: Club, key: string, isSimulator: boolean) => {
  return normalizedKeys.includes(key) && club.isNormalized && !isSimulator ? 'normalized' : '';
}

const Tiles = ({ tabSelected, club }: Props): JSX.Element => {
  const location = useSelector((state: RootState) => state.session.location);
  const isSimulator = location === LmLocation.SIMULATOR;
  // KWSA-42: Simulator sessions have their own column order. This only renders
  // once the session has loaded — SessionSharing shows a spinner until then.
  const tabs = isSimulator ? tabsGroupSim : tabsGroupClub;
  return (
    <div className="tiles">
      {tabs[tabSelected].map((tabItems: any) => (
        <div className="data-card-small" key={tabItems.avgKey}>
          <div className="data-label">
            {club.average[tabItems.avgKey as keyof Average].label}
          </div>
          <div className={`number ${normalizedClass(club, tabItems.avgKey, isSimulator)}`}>
            {club.average[tabItems.avgKey as keyof Average].value}
          </div>
          <div className="uom">
            {club.average[tabItems.avgKey as keyof Average].uom}
          </div>
        </div>
      ))}
    </div>
  );
};

Tiles.propTypes = {
  tabSelected: PropTypes.oneOf(["ball-data", "club-data", "key-data"])
};

export default Tiles;
